import React, { createContext, useContext } from 'react'

export const AbilityContext = createContext()

export const Can = props => {
  const contextAbility = useContext(AbilityContext)
  const action = props.I || props.do
  const subject = props.this || props.on || props.a || props.an || props.of
  const abilityOverride =
    props.ability && typeof props.ability.can === 'function' ? props.ability : null
  const ability = abilityOverride || contextAbility
  const allowedByAbility = action && ability ? ability.can(action, subject) : true
  const allowedByProp =
    typeof props.ability === 'boolean' ? props.ability : true
  const allowed = props.not
    ? !allowedByAbility && allowedByProp
    : allowedByAbility && allowedByProp

  if (!allowed) {
    return null
  }

  return typeof props.children === 'function'
    ? props.children()
    : <>{props.children}</>
}
